export default __webpack_public_path__ + "static/media/album_2@2x.346561f3.png";